'use strict';

module.exports = require('./createLogger');


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-util-logger/lib/index.js
// module id = 650
// module chunks = 0